module.exports = __webpack_public_path__ + "media/img/vca/sponsors/beautenails-2834557dd377e47ab367345546929723.png";